import { jsx } from "react/jsx-runtime";
import { DonationFieldWUT } from "../../../ui/donation-field/donation-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DonationWUT = (props) => {
  const { fieldType = FIELD_TYPES.DONATION } = props;
  return /* @__PURE__ */ jsx(DonationFieldWUT, { ...props, fieldType });
};
export {
  DonationWUT
};
//# sourceMappingURL=donation-wut.js.map
